// Oct 19 2026, user's ask: "remove the customer searchbox, we will update it
// manually and customer name field is not mandatory". The SAP customer list is
// off the NPD form, but the project still names the customer in its own name
// ("Geotek_PL-0197"), so picking a project pre-fills the typed name: SAP's
// spelling when its customer master knows the name, the project's own spelling
// otherwise. A project that names no customer ("P72107" is a drawing number)
// leaves whatever is in the box alone.
export const projectCustomerName = (p, current) => {
  if (!p?.customer_from_project) return current;
  return p.customer_name || p.customer_from_project;
};
